<style scoped lang="less">
@import "../../less/colors";

.slider {
    position: relative;
    height: 100%;
    text-align: center;

    &.contain .slide {
        background-size: contain;
    }
    &.cover .slide {
        background-size: cover;
    }

    .div-slide {
        opacity: 0;
        position: absolute;
        top: 0;
        left: 0;

        &.show {
            opacity: 1;
        }
    }

    .div-slide {
        height: 100%;
        width: 100%;
        transition-property: opacity;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
    }

    .img-slide {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translateX(-50%) translateY(-50%);
        opacity: 0;
        transition-property: opacity;

        &.show {
            opacity: 1;
            z-index: 99;
        }

        .img-wrapper {
            position: relative;

            & >img {
                max-width: unset !important;
                max-height: unset !important;
            }

            img.main {
                border: 1px solid black;
                box-shadow: 0px 0px 20px black;
            }

            .close, .next, .back {
                position: absolute;
                color: @white;
                top: 0;
                z-index: 110;
                min-width: 4rem;

                &:hover img{
                    transform: scale(1.15);
                }

                img {
                    width: 2rem;
                    background: rgba(0, 0, 0, 0.6);
                    margin: .5rem;
                    border-radius: 100%;
                    padding: .25rem;
                    transition: all 250ms;

                }
            }

            .next, .back {
                display: flex;
                align-items: center;
                width: 30%;
                height: 100%;
            }

            .close {
                right: 0;
            }

            .next {
                right: 0;
                text-align: right;
                justify-content: end;
            }
            .back {
                left: 0;
                justify-content: start;
                text-align: left;
            }
        }
    }
}
</style>

<template>
    <div class="slider" v-if="currentIndex !== null" :class="type" @click.self="$emit('clickedOutside')">
        <div
            v-if="type === 'cover'"
            class="div-slide"
            v-for="(file, key) in shownImages"
            :key="file.id"
            :class="[imageWidth, (parseInt(key, 10) === currentIndex ? 'show' : '')]"
            :style="{'background-image': 'url(\'' + file.thumbs[imageWidth] + '\')', 'transition-duration': transition + 'ms'}"
        >
        </div>
        <div
            v-if="type === 'contain'"
            class="img-slide"
            v-for="(file, key) in shownImages"
            :key="file.id"
            :class="[imageWidth, (parseInt(key, 10) === currentIndex ? 'show' : '')]"
            :style="{'transition-duration': transition + 'ms'}"
        >
            <div class="img-wrapper">
                <img class="main" :src="file.thumbs[imageWidth]" :alt="file.name" :style="{height: round(file.metadata.height * getFactor(file)) + 'px', width: round(file.metadata.width * getFactor(file)) + 'px'}">
                <div v-if="showControls">
                    <a class="back" href="javascript:void(0)" @click.stop="show(currentIndex - 1)" title="Back">
                        <img src="/images/chevron_left.svg">
                    </a>
                    <a class="next" href="javascript:void(0)" @click.stop="show(currentIndex + 1)" title="Next">
                        <img src="/images/chevron_right.svg">
                    </a>
                    <a class="close" href="javascript:void(0)" @click.stop="$emit('close')" title="Close">
                        <img src="/images/cross_delete.svg">
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

        data() {
            return {
                currentIndex: null,
                shownIndexes: [],
                shownImages: {},
                imageWidth: 'x150',
                client: window,
            };
        },

        props: {
            bus: Object,
            images: Array,
            type: {
                type: String,
                default: 'cover',
                validator: function (value) {
                    return ['cover', 'contain'].indexOf(value) !== -1
                }
            },
            transition: {
                type: Number,
                default: 500
            },
            showControls: {
                type: Boolean,
                default: false
            },
            allowKeys: {
                type: Boolean,
                default: false
            },
        },

        created() {
            window.addEventListener('resize', this.calcHeight);

            if (this.allowKeys) {
                document.addEventListener('keydown', this.keydown);
            }

            setTimeout(() => {
                this.calcHeight();
            });
            this.bus.$on('setClient', this.setClient);
            this.bus.$on('show', this.show);
        },
        destroyed() {
            window.removeEventListener('resize', this.calcHeight);
            if (this.allowKeys) {
                document.removeEventListener('keydown', this.keydown);
            }
        },

        methods: {

            setClient(client) {
                this.client = client;
                this.calcHeight();

            },

            calcHeight() {

                if (this.client.clientWidth < 150) {
                    this.imageWidth = 'x150';
                } else if (this.client.clientWidth < 400) {
                    this.imageWidth = 'x400';
                } else if (this.client.clientWidth < 800) {
                    this.imageWidth = 'x800';
                } else {
                    this.imageWidth = 'x1024';
                }

                this.$forceUpdate();
            },

            getFactor(file) {
                return Math.min((Math.min(this.client.clientWidth, 1024) / file.metadata.width), (Math.min(this.client.clientHeight, 1024) / file.metadata.height));
            },

            round(number){
                return Math.round(number);
            },

            keydown(e) {

                if (e.keyCode === 39 || e.keyCode === 38) {
                    this.show(this.currentIndex + 1);
                } else if(e.keyCode === 40 || e.keyCode === 37) {
                    this.show(this.currentIndex - 1);
                } else if (e.keyCode === 27) {
                    this.$emit('close');
                }

            },

            show(index) {
                index = this.addIndex(index);
                this.addIndex(index + 1);
                this.addIndex(index - 1);

                this.currentIndex = index;
                this.$emit('indexChanged', this.currentIndex);
            },

            addIndex(index) {

                if (index < 0) {
                    index = this.images.length - 1;
                } else if (index > this.images.length - 1) {
                    index = 0;
                }

                if (this.shownIndexes.indexOf(index) < 0) {
                    this.shownIndexes.push(index);
                    this.shownImages[index] = this.images[index];
                }

                return index;
            }

        }
    }
</script>
